var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1146 1300",
    style: {
      enableBackground: "new 0 0 1146 1300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M562.3,1299c-99.5-28.7-199-57.6-298.7-86.1c-44.8-12.9-89.7-25.3-134.8-36.9c-18.8-4.9-25.9-13.9-27.7-34.6 c-20-235.1-41.5-470-62.3-705C26,292.2,13.5,147.9,0.6,1c381.5,0,760.8,0,1144.8,0c-5.9,68.1-11.8,135.5-17.8,202.9 c-13.3,149.1-26.7,298.2-39.9,447.3c-14.7,165.8-28.7,331.7-44.9,497.3c-1,10.2-17.6,23.8-29.5,27.1 c-137.9,39.5-276.2,77.4-414.3,115.9c-5.3,1.5-10.2,5-15.2,7.5C576.7,1299,569.5,1299,562.3,1299z M371.1,381.1 c185.3,0,366.7,0,549.2,0c4-49.4,7.7-94.4,11.6-141.5c-240.7,0-478.1,0-718.6,0c13,145.9,25.7,288.4,38.7,433.7 c167.8,0,331.6,0,496.4,0c-2.8,35.3-4.4,67.4-8,99.4c-9.7,86.3-9.9,87-94,108.3c-29.6,7.5-61.4,18-90.4,14 c-48-6.7-94.5-24-142.3-37.1c-4-37.8-7.8-74.2-11.6-111.1c-48.6,0-94.6,0-143,0c5.9,70.6,10.8,138.6,18.5,206.2 c1,8.4,15.8,19.1,26,22.1c82.5,24.4,165.4,47.6,248.5,69.9c13.2,3.6,28.8,3.8,41.9,0.2c83.1-22.3,165.4-47,248.7-68.5 c22.6-5.8,27.4-17.4,28.7-37.6c3-46.6,8-93,12.1-139.5c7.8-89,15.3-178.2,23.4-271.5c-175.8,0-348.9,0-523.2,0 C379.2,478.1,375.3,432,371.1,381.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.c3666219dfb907a78a1aa1fd48b18caa.svg";
export { ForwardRef as ReactComponent };